import { render, staticRenderFns } from "./PublishersTable.vue?vue&type=template&id=adc17560&"
import script from "./PublishersTable.vue?vue&type=script&lang=js&"
export * from "./PublishersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports